'use es6';

import { getHubLVideoHubLTag } from 'FileManagerLib/utils/hubLVideo';
import { escape } from 'rich-text-lib/utils/iterables';
import { replaceNodes, addPostProcessTransform, addPreProcessTransform } from '../utils/transformer';
import { hublVideoPattern, attribPrefix, serializeVideoParamValue, parseHublVideoTag, getVideoParamsFromHtml, getIframeUrl, possiblyResizeVideoDimensions, createHublVideoPreview, extractIframeFromHublVideoPreview } from './util';
import { HublVideoTypes } from '../constants/hsvideo';
const replacePlaceholderWithHubL = node => {
  const hublParams = getVideoParamsFromHtml(node);
  return document.createTextNode(getHubLVideoHubLTag(hublParams));
};
const setHtmlAttributeKeyWithPropertyValue = (param, value) => {
  // uses unprefixed for `style` otherwise add prefix to preserve data
  const attribKey = param === 'style' ? param : `${attribPrefix}${param}`;
  return `${attribKey}="${escape(serializeVideoParamValue(param, value))}" `;
};
const getHtmlProps = video => {
  let res = '';
  Object.keys(video).forEach(param => {
    res += setHtmlAttributeKeyWithPropertyValue(param, video[param]);
  });
  return res;
};
export const replaceVideoHublWithIframeHtml = (editor, hublTag, content) => {
  const video = possiblyResizeVideoDimensions(editor, parseHublVideoTag(hublTag));
  const url = getIframeUrl(video, editor);
  const replacement = `<iframe class="hs-video" data-mce-hubl-video="true" src="${url}" ${getHtmlProps(video)}allowtransparency="true" allowfullscreen frameborder="0" scrolling="no" /></iframe>`;
  return content.replace(hublVideoPattern, replacement);
};
const applyPreprocessToVideoContent = (editor, domContent) => {
  let content = domContent;
  let hublVideoTagsLeftInDomContent = hublVideoPattern.exec(content);
  while (hublVideoTagsLeftInDomContent !== null) {
    if (hublVideoTagsLeftInDomContent.length) {
      content = replaceVideoHublWithIframeHtml(editor, hublVideoTagsLeftInDomContent[0], content);
    }
    hublVideoTagsLeftInDomContent = hublVideoPattern.exec(content);
  }
  return content;
};
export const addTransforms = editor => {
  addPreProcessTransform(editor, dom => {
    dom.body.innerHTML = applyPreprocessToVideoContent(editor, dom.body.innerHTML);
  });
  addPostProcessTransform(editor, dom => {
    const embedPlaceholderNodes = dom.querySelectorAll('.hs-video');
    replaceNodes(embedPlaceholderNodes, replacePlaceholderWithHubL);
  });
  editor.on('preInit', () => {
    editor.parser.addAttributeFilter('data-mce-hubl-video', nodes => {
      nodes.forEach(node => {
        const className = node.attr('class') || '';
        const videoType = node.attr('data-hs-video-type');

        // even though all videos are migrated to Video2, we cannot safely remove HublVideoTypes.VIDYARD here
        // as there are still hubl tags with `type=scriptv4` persisted in content
        if (videoType !== HublVideoTypes.VIDYARD && videoType !== HublVideoTypes.HSVIDEO2) {
          console.error(`Cannot create preview for videos of type: ${videoType}. Expected type: ${HublVideoTypes.HSVIDEO2}.`);
          return;
        }
        const videoPreview = createHublVideoPreview(editor, node);

        // Replace wrapper p if forced_root_block = "p" and the node
        // is a single child, hs-video node
        if (className && className.indexOf('hs-video') !== -1 && editor.settings.forced_root_block === 'p' && node.parent && node.parent.name === 'p' && node.parent.firstChild === node && node.parent.lastChild === node) {
          node.parent.replace(videoPreview);
        } else {
          node.replace(videoPreview);
        }
      });
    });
    editor.serializer.addAttributeFilter('data-mce-hubl-video', nodes => {
      nodes.forEach(node => {
        const iframeEl = extractIframeFromHublVideoPreview(editor, node);
        node.replace(iframeEl);
      });
    });
  });
};